var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M13.733 12.522l3.938 3.938a.857.857 0 1 1-1.211 1.211l-3.938-3.938a7.71 7.71 0 1 1 1.211-1.211zM7.71 13.706a5.996 5.996 0 1 0 0-11.993 5.996 5.996 0 0 0 0 11.993zm-2.998-5.14a.857.857 0 1 1 0-1.713h5.997a.857.857 0 1 1 0 1.713H4.71z", id: "svg1294442942a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg1294442942b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg1294442942a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg1294442942a" }),
      React.createElement(
        "g",
        { mask: "url(#svg1294442942b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1-1h20v20H-1z" })
      )
    )
  );
});